module.exports = __webpack_public_path__ + "static/media/Fischl.96297a7f.png";